import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Router from './router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children: Router,
  },
 
]


const router = new VueRouter({
	mode: "history",
	base: '/english',
	routes
});
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router;





